
import { claimNotDeclined } from './claimRules.js'

let canDeclineClaimPipeline = {
    id: 2,
    name: 'canDeclineClaimPipeline',
    rules: [
        claimNotDeclined
    ]
}

export { canDeclineClaimPipeline }